export default "__VITE_ASSET__vcbrdn1c__"